export default __webpack_public_path__ + "static/media/three_month.6ba14093.png";